/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingMemoryForAzurePendingPeriod {
    getFixupPrototypeFunction() { return CostProcessingMemoryForAzurePendingPeriod.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingMemoryForAzurePendingPeriod>): CostProcessingMemoryForAzurePendingPeriod {
        let obj = Object.assign(new CostProcessingMemoryForAzurePendingPeriod(), model);
        CostProcessingMemoryForAzurePendingPeriod.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingMemoryForAzurePendingPeriod>): CostProcessingMemoryForAzurePendingPeriod {
        if (!model) return null;
        return CostProcessingMemoryForAzurePendingPeriod.newInstance(<CostProcessingMemoryForAzurePendingPeriod> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingMemoryForAzurePendingPeriod) {
        if (!obj) return;

        models.CostProcessingMemoryForAzurePendingPeriod.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingMemoryForAzurePendingPeriod): boolean {
        Object.setPrototypeOf(obj, CostProcessingMemoryForAzurePendingPeriod.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.period_start === "string") {
            this.period_start = new Date(<string><any>this.period_start);
        }
        if (typeof this.period_end === "string") {
            this.period_end = new Date(<string><any>this.period_end);
        }
    }

    /**
     * The start date of the billing period
     */
    period_start: Date;

    /**
     * The end date of the billing period
     */
    period_end: Date;

    /**
     * URL to continuation API
     */
    link: string;

}
